import {FaClipboardList, FaCheckCircle, FaExclamationTriangle, FaUsers} from "react-icons/fa";
export const BADGE_CLASS = {
  Alta: 'create',
  Edición: 'edit',
  Eliminación: 'delete',
  Consulta: 'query',
  'Inicio de Sesión': 'session',
};

export const badgeMap = {
  create: 'badgeCreate',
  edit: 'badgeEdit',
  delete: 'badgeDelete',
  session: 'badgeSession',
  query: 'badgeQuery',
};
export const KPI_CARDS = [
  {
    key: 'totalEventos',
    label: 'Total de Eventos',
    icon: FaClipboardList,
    colorClass: 'bg-[var(--color-kpi-events)]',
  },
  {
    key: 'correctos',
    label: 'Eventos Correctos',
    icon: FaCheckCircle,
    colorClass: 'bg-[var(--color-kpi-success)]',
  },
  {
    key: 'fallidos',
    label: 'Eventos Fallidos',
    icon: FaExclamationTriangle,
    colorClass: 'bg-[var(--color-kpi-failed)]',
  },
  {
    key: 'usuariosActivos',
    label: 'Usuarios Activos',
    icon: FaUsers,
    colorClass: 'bg-[var(--color-kpi-users)]',
  },

  
];

export const ENUM_STATUS={
  true:'EXITOSO',
  false:'FALLÓ'
}
